
import { post, patch, destroy } from '../utils/api';

export const createStoryMedium = (storyId, body) => post(`/v2/stories/${storyId}/media`, body);
export const createWatchMeGrowMedium = (watch_me_grow_month_id, body) => post(`/v3/watch_me_grow_months/${watch_me_grow_month_id}/media`, body);

export const createStoryCoverMedium = (storyId, filename) =>
  post('/v2/media', {
    type: 'Image',
    data: {
      attributes: {
        type: 'Image',
        'owner-type': 'Story',
        'owner-id': storyId,
        filename,
      },
    },
  });
export const postExternalMedium = ({ externalURL, storyId, position }) =>
  post(`/v2/stories/${storyId}/media`, {
    type: 'ExternalMedia',
    data: {
      attributes: {
        type: 'ExternalMedia',
        'external-url': externalURL,
        filename: 'nonse.nse',
        'page-position': position,
      },
    },
  });

export const postMedium = ({
  attrs: { type, ownerType, ownerId, filename, preview_filename: previewFilename, ...attrs },
}) =>
  post('/v2/media', {
    type,
    data: {
      attributes: {
        type,
        filename,
        'owner-type': ownerType,
        'owner-id': ownerId,
        'preview-filename': previewFilename || attrs.previewFilename || ' ',
        ...attrs,
      },
    },
  });
export const postStoryMedium = ({ id, attributes }) =>
  post(`/v2/stories/${id}/media`, { type: attributes.type, data: { attributes } });
export const updateTextMedium = (mediumId, body) => patch(`/v2/media/${mediumId}`, body);

export const patchMedium = (mediumId, attributes) =>
  patch(`/v2/media/${mediumId}`, { data: { attributes } });

export const destroyStoryMedium = mediumId => destroy(`/v2/media/${mediumId}`);
// The S3 PUT lives in story-media/upload-medium.js. There used to be an
// `uploadMediumFile` here as well -- a bare axios.put with no retry, no telemetry
// and no state, which rejected -- and thirteen call sites imported it instead of the
// instrumented redux action. It is removed rather than deprecated so nothing can
// reach for it again.

export default createStoryMedium;
